import React from 'react'
import { faClock, faChartLine } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const SoldBoxes = () => {

  const d = [
    {id: 1, title: "Earned", value: "1.412.215.66 $", update: "June 6 | 8.39"},
    {id: 2, title: "Items Sold", value: "2037", update: "June 6 | 8.37"},
    {id: 3, title: "Items Returned", value: "32", update: "June 1 | 12.45"},
    {id: 4, title: "Quarterly Growth", value: "12%", update: "June 1 | 8.37"},
  ];
  
  return (<>
    <div className='w-100 d-flex flex-wrap text-light align-items-center justify-content-center'>
      {d.map(x => <div key={x.id} style={{background:"turquoise", minWidth:"200px", maxWidth:"320px", flexGrow:"1"}} className='rounded p-4 m-2'>
        <p className='fs-3 fw-bold'>{x.value}</p>
        <p className='fs-4 d-flex flex-wrap justify-content-between'>{x.title} <FontAwesomeIcon className='fs-2' icon={faChartLine} /></p>
        <div style={{padding:"1px"}} className="bg-light w-100 mb-3"></div>
        <div className='d-flex justify-content-between align-items-center'>
        <FontAwesomeIcon className='fs-2' icon={faClock} /> 
        <p>{x.update}</p>

      </div>
      </div>)}
    </div>
  </>)
}

export default SoldBoxes